import BaseSliderManager from "../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { SliderGenProps } from "../../../../src/types/Interface";


import { EventBus, EnumEventBus } from "./EventBus";


const SliderGen: SliderGenProps[] = [
  {
    head: "move tangent point",
    colors: {
      bgColor: 0xB5A1FF,
      barColor: 0x000000,
      buttonColor: 0xB5A1FF
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.moveTangentPoint, v - 100)
  },
  {
    head: "rotate triangle",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.moveAllPoints, v - 100)
  },
]



export default class SliderManager extends BaseSliderManager {
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL)
  }
}


/*
export default class SliderManager {
  Game = Game.getInstance();
  PointManager = PointManager.getInstance();
  EventBus = EventBus;

  moveTangentPoint: BaseSlider;
  rotateTriangle: BaseSlider;

  private dim = this.Game.getDim();
  constructor() {
    this.addSliders();
  }

  handleEnd = () => {
    this.EventBus.emit(EnumEventBus.setRefPoints);
    setTimeout(() => [this.moveTangentPoint, this.rotateTriangle].forEach(s => s.Slider.value = 100), 100);
  };
  getSliders = () => [this.moveTangentPoint, this.rotateTriangle];

  addSliders() {
    const sCoord = getSliderCoords(this.dim);
    this.addMoveTangentPoint(sCoord[0]);
    this.addRotateTriangle(sCoord[1]);
  }
  addMoveTangentPoint(coord: Coord) {
    this.moveTangentPoint = addMoveTangentPointSlider(coord, () => this.handleEnd(), (v: number) => {
      this.EventBus.emit(EnumEventBus.moveTangentPoint, v - 100);
    })
  }
  addRotateTriangle(coord: Coord) {
    this.rotateTriangle = addRotateTriangleSlider(coord, () => this.handleEnd(), (v: number) => {
      this.EventBus.emit(EnumEventBus.moveAllPoints, v - 100);
    })
  }
  setAllVisible(v: boolean) {
    this.moveTangentPoint.visible = v;
    this.rotateTriangle.visible = v;
  }
}*/